import React, { useState, useMemo, useEffect } from 'react';
import cx from 'classnames';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import '../../lists/GameList/GameListHeader/index.js';
import '../../lists/GameList/index.js';
import '../../lists/GamesListTopBar/index.js';
import '../../lists/LiveLoad/index.js';
import '../../lists/LiveWins/index.js';
import '../../lists/NavigationBar/index.js';
import '../../lists/PageNavigationBar/index.js';
import '../../lists/NavigationBarV2/index.js';
import '../../lists/PageNavigationBarV2/index.js';
import '../../lists/Pagination/index.js';
import { PaginationLocal } from '../../lists/PaginationLocal/index.js';
import '../../lists/ProvidersList/ProvidersListHeader/index.js';
import '../../lists/ProvidersList/index.js';
import '../../lists/SocialLinks/index.js';
import '../../../cards/AuthPromo/index.js';
import '../../../cards/Card/index.js';
import { CategoryCard } from '../../../cards/CategoryCard/index.js';
import '../../../cards/CryptoFeature/index.js';
import '../../../cards/GamePreview/index.js';
import '../../../cards/Promo/PromoCardSimple/index.js';
import '../../../cards/Promo/PromotionCard/index.js';
import '../../../cards/Provider/index.js';
import '../../../cards/SportsBook/index.js';
import '../../../cards/SecurityCard/index.js';
import '../../../cards/WinCard/index.js';
import styles from './index.module.scss.js';

const CategoryList = ({
  title,
  dropdown,
  data = [],
  onSelect,
  pagination,
  perPage = 9,
  onLoadMore,
  activeItem,
  text = {
    loadMore: "Load more"
  },
  className,
  style,
  ...props
}) => {
  const [paginatedList, setPaginatedList] = useState(
    pagination ? [] : data
  );
  const { windowSize } = useWindowSize();
  const isMobile = useMemo(() => windowSize.width <= 1024, [windowSize]);
  useEffect(() => {
    if (isMobile) {
      setPaginatedList(data);
    }
  }, [isMobile, data]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className, "category-list"),
      style,
      ...props
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.header }, /* @__PURE__ */ React.createElement("div", { className: styles.title }, title), dropdown),
    /* @__PURE__ */ React.createElement("div", { className: styles.body }, paginatedList.map((item) => /* @__PURE__ */ React.createElement(
      CategoryCard,
      {
        onClick: () => onSelect(item),
        data: item,
        isActive: item.id === activeItem?.id,
        key: item.id
      }
    ))),
    pagination && !isMobile && /* @__PURE__ */ React.createElement(
      PaginationLocal,
      {
        v2: true,
        data,
        className: styles.footer,
        perPage,
        onChangePage: (paginate) => setPaginatedList(paginate)
      }
    ),
    pagination && isMobile && data.length > perPage && /* @__PURE__ */ React.createElement("div", { className: styles.footer }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: styles["load-more"],
        type: "button",
        onClick: onLoadMore
      },
      text.loadMore
    ))
  );
};
CategoryList.displayName = "Wallet.CategoryList";

export { CategoryList };
//# sourceMappingURL=index.js.map
